import { render } from "./ItemMenu.vue?vue&type=template&id=53c583e2&scoped=true"
import script from "./ItemMenu.vue?vue&type=script&lang=js"
export * from "./ItemMenu.vue?vue&type=script&lang=js"

import "./ItemMenu.vue?vue&type=style&index=0&id=53c583e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c583e2"]])

export default __exports__